module.exports = __webpack_public_path__ + "static/img/12.87efb8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/12.png
// module id = kmtt
// module chunks = 0